<template>
  <div
    class="feature-point-maps"
    :style="{ width: `${gMapsWidth}px`, height: `${gMapsHeight}px` }"
  ></div>
</template>

<script>
import gmapsInit from "@/utils/gmaps";
import LoadOrReturnCategories from "@/services/LoadOrReturnCategories";

export default {
  props: {
    activeFeature: {
      type: Object,
      required: true
    },
    activePosition: {
      type: Object,
      required: true
    }
  },
  computed: {
    location() {
      let value = false;
      if (this.map) {
        this.map.setCenter({
          lat: this.$store.state.ui.latitude,
          lng: this.$store.state.ui.longitude
        });
        value = true;
      }
      return value;
    },
    gMapsWidth() {
      let viewportWidth = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );
      let sidebarWidth = 414;
      return viewportWidth - sidebarWidth;
    },
    gMapsHeight() {
      return Math.round(this.gMapsWidth * 0.4);
    },
    gMapsCoordinates() {
      return `${this.activeFeature.geometry.coordinates[1]}, ${
        this.activeFeature.geometry.coordinates[0]
      }`;
    },
    gpsLatitude() {
      return this.$store.state.ui.gpsLatitude;
    },
    gpsLongitude() {
      return this.$store.state.ui.gpsLongitude;
    },
    appAsset() {
      return this.activePosition.gemeente.app_asset
        ? this.activePosition.gemeente.app_asset
        : null;
    }
  },
  async mounted() {
    try {
      let self = this;

      gmapsInit().then(function(google) {
        var map = new google.maps.Map(self.$el, {
          disableDefaultUI: true,
          draggable: false
        });

        let geoType = self.activeFeature.geometry.type;

        self.google = google;
        self.map = map;

        if (geoType == "Point") {
          self.createPointAdditions();
        } else if (geoType == "Polygon") {
          self.createPolygonAdditions();
        }
      });
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    setPointBounds(positionLocation, featureLocation) {
      var bounds = new self.google.maps.LatLngBounds();
      var i;

      let boundsLocations = [positionLocation, featureLocation];
      for (i = 0; i < boundsLocations.length; i++) {
        bounds.extend(boundsLocations[i]);
      }

      this.map.fitBounds(this.circle.getBounds(), 0);
      this.map.panTo(bounds.getCenter());
    },
    createPointAdditions() {
      if (this.polygon) {
        this.polygon.setMap(null);
      }
      let self = this;

      let position = {
        lat: this.activePosition.latitude,
        lng: this.activePosition.longitude
      };

      this.map.setCenter(position);

      if (this.marker && this.circle) {
        LoadOrReturnCategories().then(function(categories) {
          let category = categories.data.find(
            x => x.id == self.activeFeature.properties.category_id
          );

          let newPosition = {
            lat: self.activeFeature.geometry.coordinates[1],
            lng: self.activeFeature.geometry.coordinates[0]
          };

          self.marker_two.setPosition(newPosition);
          self.marker_two.setIcon({
            url: category.icon_url,
            anchor: new self.google.maps.Point(16, 16),
            scaledSize: new self.google.maps.Size(48, 48)
          });

          self.setPointBounds(position, newPosition);
        });
      } else {
        var marker = new this.google.maps.Marker({
          map: this.map,
          position: position,
          icon: {
            url: "/ic_location@2x.png",
            anchor: new google.maps.Point(16, 16),
            scaledSize: new google.maps.Size(32, 32)
          }
        });

        LoadOrReturnCategories().then(function(categories) {
          let category = categories.data.find(
            x => x.id == self.activeFeature.properties.category_id
          );

          let newPosition = {
            lat: self.activeFeature.geometry.coordinates[1],
            lng: self.activeFeature.geometry.coordinates[0]
          };

          var marker_two = new self.google.maps.Marker({
            map: self.map,
            position: newPosition,
            icon: {
              url: category.icon_url,
              anchor: new self.google.maps.Point(16, 16),
              scaledSize: new self.google.maps.Size(48, 48)
            }
          });

          var circle = new self.google.maps.Circle({
            map: self.map,
            strokeWeight: 0,
            fillColor: self.appAsset ? self.appAsset.color_primary : "#6DCC00",
            fillOpacity: 0.33,
            center: position,
            radius: self.activePosition.radius
          });

          self.marker = marker;
          self.marker_two = marker_two;
          self.circle = circle;
          self.setPointBounds(position, newPosition);
        });
      }
    },
    createPolygonAdditions() {
      if (this.circle) {
        this.circle.setMap(null);
      }
      if (this.marker) {
        this.marker.setMap(null);
      }
      if (this.marker_two) {
        this.marker_two.setMap(null);
      }

      let position = {
        lat: this.activePosition.latitude,
        lng: this.activePosition.longitude
      };

      new this.google.maps.Marker({
        map: this.map,
        position: position,
        icon: {
          url: "/ic_location@2x.png",
          anchor: new google.maps.Point(16, 16),
          scaledSize: new google.maps.Size(32, 32)
        }
      });

      let newCoords = [];
      let coordinates = this.activeFeature.geometry.coordinates[0];

      coordinates.forEach(function(coord) {
        newCoords.push({
          lat: coord[1],
          lng: coord[0]
        });
      });

      var bounds = new this.google.maps.LatLngBounds();
      var i;

      for (i = 0; i < newCoords.length; i++) {
        bounds.extend(newCoords[i]);
      }

      bounds.extend(position);
      this.map.fitBounds(bounds, 0);

      if (!this.polygon) {
        var polygon = new this.google.maps.Polygon({
          map: this.map,
          paths: newCoords,
          strokeWeight: 5,
          strokeColor: "#000",
          fillColor: this.appAsset ? this.appAsset.color_primary : "#6DCC00",
          fillOpacity: 0.33
        });
        this.polygon = polygon;
      } else {
        this.polygon.setPaths(newCoords);
      }
    }
  },
  watch: {
    activeFeature() {
      let geoType = this.activeFeature.geometry.type;

      if (geoType == "Point") {
        this.createPointAdditions();
      } else if (geoType == "Polygon") {
        this.createPolygonAdditions();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.feature-point-maps {
  // width: 500px;
  // height: 500px;
}

@media (max-width: 768px) {
  .feature-point-maps {
    width: 100% !important;
    height: 40vh !important;
  }
}
</style>
